export default __webpack_public_path__ + "static/media/revert_photo_test.bbb5512f.jpg";